"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUsers = exports.ProjectsActions = exports.CurrentActions = void 0;
const _currentActions = require("../../modules/customer/current/actions");
const _projectsActions = require("../../modules/project/list/actions");
const _projectUsers = require("./projectUsers");
exports.CurrentActions = _currentActions.default('management');
exports.ProjectsActions = _projectsActions.default('management');
exports.ProjectUsers = _projectUsers;
//# sourceMappingURL=index.js.map